 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Auth":"Auth","InstallTip":"InstallTip","Resource":"Resource","auditManage":"auditManage","classManage":"classManage","classStudentManage":"classStudentManage","compared~course~usage":"compared~course~usage","compared":"compared","course":"course","usage":"usage","courseList":"courseList","evaluationManage":"evaluationManage","hdClassroom~hdTeaching~teaching~teachingWpsDialog":"hdClassroom~hdTeaching~teaching~teachingWpsDialog","hdTeaching~teaching":"hdTeaching~teaching","hdTeaching":"hdTeaching","teachingWpsDialog":"teachingWpsDialog","home~rescourceAnalyze":"home~rescourceAnalyze","rescourceAnalyze":"rescourceAnalyze","login":"login","lookWps":"lookWps","my":"my","myCourses":"myCourses","home":"home","not-found":"not-found","orderDetail":"orderDetail","orderList":"orderList","prepareRecord":"prepareRecord","questionnaireResult":"questionnaireResult","refundApplication":"refundApplication","refundDetail":"refundDetail","resourceManage":"resourceManage","rolemanage":"rolemanage","shareRecord":"shareRecord","statisticalBoard":"statisticalBoard","studentManage":"studentManage","studentReported":"studentReported","tabManage":"tabManage","teachManage":"teachManage","teachingRecord":"teachingRecord","vendors~CourseDetails~classroom~hdClassroom~hdCourseDetails":"vendors~CourseDetails~classroom~hdClassroom~hdCourseDetails","CourseDetails~classroom":"CourseDetails~classroom","CourseDetails":"CourseDetails","hdCourseDetails":"hdCourseDetails","vendors~classroom~courseRecommendations~hdClassroom":"vendors~classroom~courseRecommendations~hdClassroom","vendors~classroom~hdClassroom":"vendors~classroom~hdClassroom","classroom":"classroom","hdClassroom":"hdClassroom","vendors~authorize~batchUserPermission":"vendors~authorize~batchUserPermission","authorize~batchUserPermission":"authorize~batchUserPermission","authorize":"authorize","batchUserPermission":"batchUserPermission","courseRecommendations":"courseRecommendations","vendors~layout":"vendors~layout","layout":"layout","vendors~teaching":"vendors~teaching","teaching":"teaching"}[chunkId]||chunkId) + ".1773903313465.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-23b4c4a1":1,"chunk-1c5bec2a":1,"Auth":1,"InstallTip":1,"Resource":1,"auditManage":1,"classManage":1,"classStudentManage":1,"compared~course~usage":1,"compared":1,"course":1,"usage":1,"courseList":1,"evaluationManage":1,"hdTeaching~teaching":1,"hdTeaching":1,"teachingWpsDialog":1,"home~rescourceAnalyze":1,"rescourceAnalyze":1,"lookWps":1,"my":1,"myCourses":1,"home":1,"not-found":1,"orderDetail":1,"orderList":1,"prepareRecord":1,"questionnaireResult":1,"refundApplication":1,"refundDetail":1,"resourceManage":1,"rolemanage":1,"shareRecord":1,"statisticalBoard":1,"studentManage":1,"studentReported":1,"tabManage":1,"teachManage":1,"teachingRecord":1,"vendors~CourseDetails~classroom~hdClassroom~hdCourseDetails":1,"CourseDetails~classroom":1,"CourseDetails":1,"hdCourseDetails":1,"vendors~classroom~courseRecommendations~hdClassroom":1,"vendors~classroom~hdClassroom":1,"classroom":1,"hdClassroom":1,"authorize~batchUserPermission":1,"authorize":1,"batchUserPermission":1,"courseRecommendations":1,"layout":1,"teaching":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Auth":"Auth","InstallTip":"InstallTip","Resource":"Resource","auditManage":"auditManage","classManage":"classManage","classStudentManage":"classStudentManage","compared~course~usage":"compared~course~usage","compared":"compared","course":"course","usage":"usage","courseList":"courseList","evaluationManage":"evaluationManage","hdClassroom~hdTeaching~teaching~teachingWpsDialog":"hdClassroom~hdTeaching~teaching~teachingWpsDialog","hdTeaching~teaching":"hdTeaching~teaching","hdTeaching":"hdTeaching","teachingWpsDialog":"teachingWpsDialog","home~rescourceAnalyze":"home~rescourceAnalyze","rescourceAnalyze":"rescourceAnalyze","login":"login","lookWps":"lookWps","my":"my","myCourses":"myCourses","home":"home","not-found":"not-found","orderDetail":"orderDetail","orderList":"orderList","prepareRecord":"prepareRecord","questionnaireResult":"questionnaireResult","refundApplication":"refundApplication","refundDetail":"refundDetail","resourceManage":"resourceManage","rolemanage":"rolemanage","shareRecord":"shareRecord","statisticalBoard":"statisticalBoard","studentManage":"studentManage","studentReported":"studentReported","tabManage":"tabManage","teachManage":"teachManage","teachingRecord":"teachingRecord","vendors~CourseDetails~classroom~hdClassroom~hdCourseDetails":"vendors~CourseDetails~classroom~hdClassroom~hdCourseDetails","CourseDetails~classroom":"CourseDetails~classroom","CourseDetails":"CourseDetails","hdCourseDetails":"hdCourseDetails","vendors~classroom~courseRecommendations~hdClassroom":"vendors~classroom~courseRecommendations~hdClassroom","vendors~classroom~hdClassroom":"vendors~classroom~hdClassroom","classroom":"classroom","hdClassroom":"hdClassroom","vendors~authorize~batchUserPermission":"vendors~authorize~batchUserPermission","authorize~batchUserPermission":"authorize~batchUserPermission","authorize":"authorize","batchUserPermission":"batchUserPermission","courseRecommendations":"courseRecommendations","vendors~layout":"vendors~layout","layout":"layout","vendors~teaching":"vendors~teaching","teaching":"teaching"}[chunkId]||chunkId) + ".1773903313465.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://js.hlestudy.com/aifrontsuball/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
